<template>
  <div id="messagePush">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('interaction.messageType')" >
                <el-select v-model="filterForm.businessSystem" :placeholder="$t('interaction.chooseType')" clearable>
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.key"
                    :label="item.key"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('interaction.createTime')" >
                <el-date-picker
                  style="width: 100%"
                  v-model="filterForm.createTime"
                  type="date"
                  :placeholder="$t('interaction.chooseCreateTime')"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('interaction.startTime')" >
                <el-date-picker
                  style="width: 100%"
                  v-model="filterForm.startDate"
                  type="date"
                  :placeholder="$t('survey.startTime')"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('interaction.endTime')" >
                <el-date-picker
                  style="width: 100%"
                  v-model="filterForm.endDate"
                  type="date"
                  :placeholder="$t('survey.endTime')"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
<!--              <el-form-item :label="$t('interaction.messageStatus')" >-->
<!--                <el-select v-model="filterForm.status" :placeholder="$t('interaction.chooseMessageStatus')" clearable>-->
<!--                  <el-option-->
<!--                    v-for="item in statusOptions"-->
<!--                    :key="item.key"-->
<!--                    :label="item.key"-->
<!--                    :value="item.value">-->
<!--                  </el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="20">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="filterBtns">
                  <el-button type="primary" @click="openAdd">{{ $t('new') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="tableData" v-loading="tableLoading">
              <el-table-column sortable prop="title" :label="$t('interaction.title')"></el-table-column>
              <el-table-column sortable prop="content" :label="$t('interaction.messageContent')" width="300"></el-table-column>
              <el-table-column sortable prop="businessSystem" :label="$t('interaction.messageType')"></el-table-column>
              <el-table-column sortable prop="createTime" :label="$t('interaction.createTime')" width="170"></el-table-column>
              <el-table-column sortable prop="actualPushTime" :label="$t('interaction.sendTime')" width="170"></el-table-column>
              <el-table-column sortable prop="status" :label="$t('interaction.sendType')"></el-table-column>
              <el-table-column sortable prop="readersNumber" :label="$t('interaction.readNum')"></el-table-column>
              <el-table-column :label="$t('operation')">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="openEdit(scope.row.id)" v-if="scope.row.status === '待发送'">{{ $t('edit') }}</el-button>
                  <el-button type="text" size="small" @click="cancel(scope.row.id)" v-if="scope.row.status === '已发送'">
                    {{ $t('interaction.rollback') }}</el-button>
                  <el-button type="text" size="mini" @click="deleteMessage(scope.row.id)">{{ $t('delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 编辑 -->
    <el-dialog
      :title="dialogType + '通知'"
      :visible.sync="dialogVisible"
      width="40%"
      center
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        ref="editForm"
        label-width="100px"
      >
        <multiLangInput
          :label="$t('interaction.title')"
          labelWidth="100"
          :required="true"
          v-model="editForm.titleMulti"
          :hasEn="false"
        />
        <multiLangInput
          :label="$t('interaction.messageContent')"
          labelWidth="100"
          :required="true"
          v-model="editForm.contentMulti"
          :hasEn="false"
        />
        <el-form-item :label="$t('interaction.messageType')" prop="">
          <el-select
            v-model="editForm.businessSystem"
            clearable
            :placeholder="$t('interaction.chooseType')"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in typeOptions"
              :key="index"
              :label="item.key"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('interaction.messageType')">
          <el-radio-group v-model="editForm.sendType">
            <el-radio :label="2">{{ $t('interaction.immediateSend') }}</el-radio>
<!--            <el-radio :label="3">{{ $t('interaction.laterSend') }}</el-radio>-->
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="$t('interaction.sendTime')" v-if="editForm.sendType === 3">
          <el-date-picker
            style="width: 100%"
            v-model="editForm.prePushTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('interaction.sendTime')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitNotice">{{ $t('save') }}</el-button>
          <el-button type="primary" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import anyImageUpload from "@/components/anyImageUpload";
import multiLangInput from '@/components/multiLangInput';
import { multiInputFormat } from '../../utils/global'

export default {
  name: 'Popup',
  components: {
    anyImageUpload,
    multiLangInput
  },
  data: function () {
    return {
      dialogType: '',
      initEditForm: {
        titleMulti: _.clone(multiInputFormat), // 标题
        contentMulti: _.clone(multiInputFormat), // 内容
        content: '',
        prePushTime: '',
        businessSystem: '',
        title: '',
        sendType: 2,
        traditionalContent: '',
        traditionalTitle: ''
      },
      editForm: {
      }, // 表单
      filterForm: {
        businessSystem: '', // 通知类型
        status: '', // 状态
        startDate: '', // 开始时间
        endDate: '', // 结束时间
        createTime: '', // 创建时间
      },
      initFilterForm: {
        businessSystem: '', // 通知类型
        status: '', // 状态
        startDate: '', // 开始时间
        endDate: '', // 结束时间
        createTime: '', // 创建时间
      },
      loading: false,
      dialogVisible: false, // 弹框显示
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      statusOptions: [
        {
          key: '已发送',
          value: 1
        },
        {
          key: '待发送',
          value: 0
        }
      ],
      typeOptions: [],
    }
  },
  mounted () {
    this.getTypeOptions()
  },

  methods: {
    async cancel(id) {
      await this.$confirm('确定撤回该消息吗?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await window.instance.post(window.retailinkUrl + '/notice/revocation/' + id)
        res = res.data
        if (res.code === 200) {
          this.onSearch(true)
          this.$message({
            type: 'success',
            message: '撤回成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    async getTypeOptions() {
      let res = await window.instance.post(window.retailinkUrl + '/mqApi/systemType')
      res = res.data
      if (res.code === 200) {
        this.typeOptions = _.map(res.data, (type) => ({
          key: type.desc,
          value: type.code
        }))
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    onReset() {
      // 重置
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },

    async deleteMessage(id) {
      await this.$confirm('确定删除该消息吗?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await window.instance.post(window.retailinkUrl + '/notice/delNotice/' + id)
        res = res.data
        if (res.code === 200) {
          this.onSearch(true)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    openAdd () {
      this.dialogVisible = true
      this.dialogType = '新增'
      this.editForm = _.cloneDeep(this.initEditForm)
    },
    openEdit (id) {
      this.dialogVisible = true
      this.dialogType = '编辑'
      this.getData(id)
    },
    getData: async function (id) {
      let res = await window.instance.post(window.retailinkUrl + '/notice/getNoticeDetail/' + id)
      res = res.data
      if (res.code === 200) {
        console.log('res', res)
        const editForm = {}
        editForm.id = id
        editForm.titleMulti = {
          'zh_CN': res.data.title,
          'zh_HK': res.data.traditionalTitle,
          'en': ''
        }
        editForm.contentMulti = {
          'zh_CN': res.data.content,
          'zh_HK': res.data.traditionalContent,
          'en': ''
        }
        editForm.content = res.data.content
        editForm.businessSystem = res.data.businessSystem
        editForm.title = res.data.title
        editForm.sendType = res.data.sendType
        if (editForm.sendType === 3) {
          editForm.prePushTime = res.data.prePushTime
        }
        this.editForm = _.cloneDeep(editForm)
      }
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let res = await window.instance.post(window.retailinkUrl + '/notice/listMessage', _.assign(this.filterForm, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.records
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },

    // 保存消息(新增/编辑)
    submitNotice: async function () {
      console.log('editform', this.editForm)
      const isEdit = !_.isNil(this.editForm.id)
      let submitParams = {}
      if (isEdit) {
        submitParams.id = this.editForm.id
      }
      submitParams.businessSystem = this.editForm.businessSystem
      submitParams.sendType = this.editForm.sendType
      if (submitParams.sendType === 3) {
        submitParams.prePushTime = this.editForm.prePushTime
      }
      submitParams.content = this.editForm.contentMulti.zh_CN
      submitParams.title = this.editForm.titleMulti.zh_CN
      submitParams.traditionalContent = this.editForm.contentMulti.zh_HK
      submitParams.traditionalTitle = this.editForm.titleMulti.zh_HK
      let submitUrl = ''
      if (isEdit) {
        submitUrl = '/notice/updateCustom'
      } else {
        submitUrl = '/notice/saveCustom'
      }
      let res = await window.instance.post(window.retailinkUrl + submitUrl, submitParams)
      res = res.data
      if (res.code === 200) {
        console.log('res', res)
        this.$message.success(res.message)
        this.dialogVisible = false
        this.onSearch(!isEdit)
      }
    }
  }
}
</script>

<style scoped lang="sass">
#messagePush

</style>



// WEBPACK FOOTER //
// src/pages/interaction/messagePush.vue